/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { keyframes } from "styled-components";
import { FontWeight } from "components/Text";
import { mediaHelper } from "../../utils/src";
import globalStyles from "globalStyles";
import { Label } from "@fitinsur/components";

export const Content = styled.div`
  padding: 10px 0 0;
`;

export const Text = styled.text`
  display: block;
  color: ${globalStyles.components.brokingSummary.text};
  font-weight: ${FontWeight.SemiBold};
  text-transform: uppercase;
  font-size: 14px;
  margin-bottom: 5px;

  ${mediaHelper.sm`
    font-size: 16px;
  `}
`;

export const CustomLabel = styled(Label)`
  display: block;
  color: ${globalStyles.components.brokingSummary.label};
  font-weight: ${FontWeight.Bold};
  font-size: 12px;

  ${mediaHelper.sm`
    font-size: 14px;
  `}
`;

const slide = keyframes`
  from {
    background-position: 200% 0;
  }
  to {
    background-position: -200% 0;
  }
`;

// Styled component for the loading container
export const LoaderContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
`;

// Styled component for the loading bar
export const LoaderBar = styled.div`
  width: 50%;
  height: 20px;
  background: linear-gradient(to right, #ddd 25%, #aaa 50%, #ddd 75%);
  background-size: 200% 100%;
  animation: ${slide} 3s linear infinite;
`;